import React, {
  useEffect,
  useState
} from "react";

import rfqService from "../services/rfqService";
import RFQQuoteEntryGrid from "./components/RFQQuoteEntryGrid";

import "../rfq-ui.css";

export default function RFQQuoteEntryInternal() {

  const [rfqId, setRfqId] = useState("");

  const [vendorId, setVendorId] = useState("");

  const [rfqs, setRfqs] = useState([]);

  const [vendors, setVendors] = useState([]);

  const [lines, setLines] = useState([]);

  const [loading, setLoading] = useState(false);

  // ==========================================================
  // LOAD RFQs
  // ==========================================================

  useEffect(() => {
    loadRFQs();
  }, []);

  
  const handleSave = async () => {

  try {

    await rfqService.submitInternalQuote(
      rfqId,
      vendorId,
      lines
    );

    alert(
      "Quotation saved successfully"
    );

    loadQuoteData(
      rfqId,
      vendorId
    );

  } catch (err) {

    alert(
      err?.response?.data?.message ||
      "Failed to save quotation"
    );

  }
};
  
  const loadRFQs = async () => {

  try {

    const res =
      await rfqService.getQuoteEntryRFQs();

    setRfqs(
      res?.data?.data || []
    );

  } catch (err) {

    console.error(err);

  }
};

  // ==========================================================
  // LOAD VENDORS
  // ==========================================================

  const loadVendors = async (
    selectedRFQ
  ) => {

    try {

      const res =
        await rfqService.getRFQVendors(
          selectedRFQ
        );

      setVendors(
        res?.data?.data || []
      );

    } catch (err) {

      console.error(err);

    }
  };

  // ==========================================================
  // LOAD QUOTE DATA
  // ==========================================================

  const loadQuoteData = async (
    selectedRFQ,
    selectedVendor
  ) => {

    try {

      setLoading(true);

      const res =
        await rfqService.getQuoteEntryData(
          selectedRFQ,
          selectedVendor
        );

      setLines(
        res?.data?.data?.lines || []
      );

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);

    }
  };

  // ==========================================================
  // RFQ CHANGE
  // ==========================================================

  const handleRFQChange = (
    value
  ) => {

    setRfqId(value)

    setVendorId("");

    setLines([]);

    loadVendors(value);
  };

  // ==========================================================
  // VENDOR CHANGE
  // ==========================================================

  const handleVendorChange = (
    value
  ) => {

    setVendorId(value);

    loadQuoteData(
      rfqId,
      value
    );
  };

  return (

    <div>

      <div className="rfq-header-card">

        <h2>
          RFQ Quote Entry
        </h2>

        <p>
          Internal Vendor Quote Entry
        </p>

      </div>

      <div className="rfq-filters">

        <select
          value={rfqId}
          onChange={(e) =>
            handleRFQChange(
              e.target.value
            )
          }
        >
          <option value="">
            Select RFQ
          </option>

          {rfqs.map((rfq) => (

            <option
              key={rfq.id}
              value={rfq.id}
            >
              {rfq.rfq_no}
            </option>

          ))}

        </select>

        <select
          value={vendorId}
          onChange={(e) =>
            handleVendorChange(
              e.target.value
            )
          }
        >
          <option value="">
            Select Vendor
          </option>

          {vendors.map((vendor) => (

            <option
              key={vendor.vendor_id}
              value={vendor.vendor_id}
            >
              {vendor.vendor_name}
            </option>

          ))}

        </select>

      </div>

      {loading && (
        <div>
          Loading...
        </div>
      )}

      {!loading && lines.length > 0 && (
  <>
    <RFQQuoteEntryGrid
      lines={lines}
      setLines={setLines}
    />

    <div
      style={{
        marginTop: "20px",
        textAlign: "right"
      }}
    >
      <button
        className="btn-primary"
        onClick={handleSave}
      >
        Save Quote
      </button>
    </div>
  </>
)}

    </div>
  );
}